<app-state-view class="results-listing" [state]="state">
  <loading-state>
    <app-dots-spinner aria-label="Loading..."></app-dots-spinner>
  </loading-state>
  <empty-state>
    <div class="results-listing__placeholder">
      <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
      <div class="results-listing__placeholder-message">Please zoom in or enter a search query to perform a search.</div>
    </div>
  </empty-state>
  <error-state>
    <div class="results-listing__placeholder results-listing__placeholder--error">
      <mat-icon class="results-listing__placeholder-icon">warning</mat-icon>
      <div class="results-listing__placeholder-message">
        {{ errorMessage || 'An error occurred performing the search. Please try again later.' }}
      </div>
    </div>
  </error-state>
  <content-state>
    <div class="results-listing__container">
      <div class="results-listing__filter-bar">
        <button #activityPopoverAnchor="satPopoverAnchor"
                type="button" class="results-listing__filter"
                [satPopoverAnchorFor]="activityFiltersPopover" (click)="activityFiltersPopover.toggle()"
                [class.results-listing__filter--active]="activityPopoverAnchor.isPopoverOpen()">
          Activities: {{ activityLabel || 'None' }}
          <mat-icon class="results-listing__filter-arrow">keyboard_arrow_down</mat-icon>
        </button>
      </div>
      <div #listEl *ngIf="activities && activities.length > 0; else placeholder" class="results-listing__list">
        <app-activity-summary-card #activityEl
          *ngFor="let activity of activities"
          [activity]="activity" [active]="activity === activeActivity"
          (activityMouseEnter)="onActivityHover(activity, true)"
          (activityMouseLeave)="onActivityHover(activity, false)">
        </app-activity-summary-card>
      </div>
    </div>
  </content-state>
</app-state-view>

<ng-template #placeholder>
  <div class="results-listing__placeholder">
    <mat-icon class="results-listing__placeholder-icon">info</mat-icon>
    <div class="results-listing__placeholder-message">No results found matching your search criteria.</div>
  </div>
</ng-template>

<sat-popover #activityFiltersPopover horizontalAlign="start" verticalAlign="below" [autoFocus]="false" hasBackdrop>
  <div class="results-listing__popover results-listing__popover--activities">
    <app-activity-filter-list #activityFilters [query]="query" [(selectedActivity)]="query.activity"
                              (selectedActivityChange)="onSelectedActivityChange($event)"
                              [compact]="true">
    </app-activity-filter-list>
  </div>
</sat-popover>
